const config = state => state.app.config;
const palette = state => state.app.config.palette;
const isLoading = state => state.app.isLoading;
const loadEntreprise = state => state.app.loadEntreprise;
const user = state => state.auth.user;
const isLoggedIn = state => state.auth.isLoggedIn;
const authStatus = state => state.auth.status;
const userList = state => state.auth.userList;
const statEntreprises = state => state.app.statEntreprises;
const listeCCN = state => state.app.listeCCN;

export {
  config,
  palette,
  isLoading,
  user,
  isLoggedIn,
  authStatus,
  userList,
  loadEntreprise,
  statEntreprises,
  listeCCN
};
